import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-99933182"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "add-agency"
};
const _hoisted_2 = {
  class: "myform"
};

const _hoisted_3 = /*#__PURE__*/_createTextVNode("上级");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("名称");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("登录密码");

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "  登录密码必需包含大小写字母和数字，最少8位", -1));

const _hoisted_7 = /*#__PURE__*/_createTextVNode("赔率复制");

const _hoisted_8 = /*#__PURE__*/_createTextVNode("公司名称");

const _hoisted_9 = /*#__PURE__*/_createTextVNode("额度还原");

const _hoisted_10 = /*#__PURE__*/_createTextVNode("开启");

const _hoisted_11 = /*#__PURE__*/_createTextVNode("关闭");

const _hoisted_12 = /*#__PURE__*/_createTextVNode("额度模式");

const _hoisted_13 = /*#__PURE__*/_createTextVNode("现金");

const _hoisted_14 = /*#__PURE__*/_createTextVNode("混合");

const _hoisted_15 = /*#__PURE__*/_createTextVNode("信用");

const _hoisted_16 = /*#__PURE__*/_createTextVNode("现金");

const _hoisted_17 = /*#__PURE__*/_createTextVNode("信用");

const _hoisted_18 = /*#__PURE__*/_createTextVNode("混合");

const _hoisted_19 = /*#__PURE__*/_createTextVNode("操盘");

const _hoisted_20 = /*#__PURE__*/_createTextVNode("开启");

const _hoisted_21 = /*#__PURE__*/_createTextVNode("关闭");

const _hoisted_22 = /*#__PURE__*/_createTextVNode("赚取赔率差");

const _hoisted_23 = /*#__PURE__*/_createTextVNode("开启");

const _hoisted_24 = /*#__PURE__*/_createTextVNode("关闭");

const _hoisted_25 = /*#__PURE__*/_createTextVNode("- ");

const _hoisted_26 = /*#__PURE__*/_createTextVNode("彩种选择");

const _hoisted_27 = /*#__PURE__*/_createTextVNode("快彩");

const _hoisted_28 = /*#__PURE__*/_createTextVNode("香港六合");

const _hoisted_29 = /*#__PURE__*/_createTextVNode("澳门六合");

const _hoisted_30 = /*#__PURE__*/_createTextVNode("新澳门六合");

const _hoisted_31 = /*#__PURE__*/_createTextVNode("下线占成上限(快彩)");

const _hoisted_32 = /*#__PURE__*/_createTextVNode("占余成数下线任占");

const _hoisted_33 = /*#__PURE__*/_createTextVNode("限制下线可占成数");

const _hoisted_34 = {
  key: 0,
  style: {
    "display": "inline-block",
    "margin-left": "10px"
  }
};

const _hoisted_35 = /*#__PURE__*/_createTextVNode("占余成数归(快彩)");

const _hoisted_36 = /*#__PURE__*/_createTextVNode("盘口(快彩)");

const _hoisted_37 = /*#__PURE__*/_createTextVNode("不限");

const _hoisted_38 = /*#__PURE__*/_createTextVNode("A盘");

const _hoisted_39 = /*#__PURE__*/_createTextVNode("B盘");

const _hoisted_40 = /*#__PURE__*/_createTextVNode("C盘");

const _hoisted_41 = /*#__PURE__*/_createTextVNode("下线占成上限(六合)");

const _hoisted_42 = /*#__PURE__*/_createTextVNode("占余成数下线任占");

const _hoisted_43 = /*#__PURE__*/_createTextVNode("限制下线可占成数");

const _hoisted_44 = {
  key: 0,
  style: {
    "display": "inline-block",
    "margin-left": "10px"
  }
};

const _hoisted_45 = /*#__PURE__*/_createTextVNode("占余成数归(六合)");

const _hoisted_46 = /*#__PURE__*/_createTextVNode("盘口(六合)");

const _hoisted_47 = /*#__PURE__*/_createTextVNode("不限");

const _hoisted_48 = /*#__PURE__*/_createTextVNode("A盘");

const _hoisted_49 = /*#__PURE__*/_createTextVNode("B盘");

const _hoisted_50 = /*#__PURE__*/_createTextVNode("C盘");

const _hoisted_51 = /*#__PURE__*/_createTextVNode("退水设定");

const _hoisted_52 = {
  key: 0,
  class: "auto_draw_back"
};

const _hoisted_53 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "auto_draw_back",
  style: {
    "margin-left": "15px"
  }
}, "赚取：", -1));

const _hoisted_54 = /*#__PURE__*/_createTextVNode("补货");

const _hoisted_55 = /*#__PURE__*/_createTextVNode("开启");

const _hoisted_56 = /*#__PURE__*/_createTextVNode("关闭");

const _hoisted_57 = /*#__PURE__*/_createTextVNode("状态");

const _hoisted_58 = /*#__PURE__*/_createTextVNode("开启");

const _hoisted_59 = /*#__PURE__*/_createTextVNode("关闭");

const _hoisted_60 = /*#__PURE__*/_createTextVNode("快彩信用额度");

const _hoisted_61 = /*#__PURE__*/_createTextVNode("六合信用额度");

const _hoisted_62 = /*#__PURE__*/_createTextVNode("确认新增");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_col = _resolveComponent("el-col");

  const _component_el_option = _resolveComponent("el-option");

  const _component_el_select = _resolveComponent("el-select");

  const _component_el_row = _resolveComponent("el-row");

  const _component_el_input = _resolveComponent("el-input");

  const _component_warning_filled = _resolveComponent("warning-filled");

  const _component_el_icon = _resolveComponent("el-icon");

  const _component_el_popover = _resolveComponent("el-popover");

  const _component_el_radio = _resolveComponent("el-radio");

  const _component_el_radio_group = _resolveComponent("el-radio-group");

  const _component_el_checkbox = _resolveComponent("el-checkbox");

  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group");

  const _component_el_button = _resolveComponent("el-button");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_row, {
    class: "myform-item"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      class: "myform-item-lable",
      span: 6
    }, {
      default: _withCtx(() => [_hoisted_3]),
      _: 1
    }), _createVNode(_component_el_col, {
      class: "myform-item-value",
      span: 18
    }, {
      default: _withCtx(() => [_createVNode(_component_el_select, {
        modelValue: $data.sltuid,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.sltuid = $event),
        size: "small",
        style: {
          "width": "140px"
        },
        onChange: $options.get_user_edit
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.addinfo.sub_list, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.id,
            label: item.username,
            value: item.id
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue", "onChange"])]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "myform-item"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      class: "myform-item-lable",
      span: 6
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString($props.addinfo.sub_group_name) + "账号", 1)]),
      _: 1
    }), _createVNode(_component_el_col, {
      class: "myform-item-value",
      span: 18
    }, {
      default: _withCtx(() => [_createVNode(_component_el_popover, {
        visible: $data.err.name.visible,
        placement: "right"
      }, {
        reference: _withCtx(() => [_createVNode(_component_el_input, {
          style: {
            "width": "140px"
          },
          modelValue: $data.name,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.name = $event),
          modelModifiers: {
            trim: true
          },
          size: "small",
          placeholder: "请输入登录账号",
          clearable: "",
          onFocus: _cache[2] || (_cache[2] = $event => $data.err.name.visible = false)
        }, null, 8, ["modelValue"])]),
        default: _withCtx(() => [_createElementVNode("span", null, [_createVNode(_component_el_icon, {
          color: "red",
          size: "20px"
        }, {
          default: _withCtx(() => [_createVNode(_component_warning_filled)]),
          _: 1
        }), _createElementVNode("span", null, _toDisplayString($data.err.name.content), 1)])]),
        _: 1
      }, 8, ["visible"])]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "myform-item"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      class: "myform-item-lable",
      span: 6
    }, {
      default: _withCtx(() => [_hoisted_4]),
      _: 1
    }), _createVNode(_component_el_col, {
      class: "myform-item-value",
      span: 18
    }, {
      default: _withCtx(() => [_createVNode(_component_el_popover, {
        visible: $data.err.nickname.visible,
        placement: "right"
      }, {
        reference: _withCtx(() => [_createVNode(_component_el_input, {
          style: {
            "width": "140px"
          },
          modelValue: $data.nickname,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.nickname = $event),
          modelModifiers: {
            trim: true
          },
          size: "small",
          placeholder: "请输入名称",
          clearable: "",
          onFocus: _cache[4] || (_cache[4] = $event => $data.err.nickname.visible = false)
        }, null, 8, ["modelValue"])]),
        default: _withCtx(() => [_createElementVNode("span", null, [_createVNode(_component_el_icon, {
          color: "red",
          size: "20px"
        }, {
          default: _withCtx(() => [_createVNode(_component_warning_filled)]),
          _: 1
        }), _createElementVNode("span", null, _toDisplayString($data.err.nickname.content), 1)])]),
        _: 1
      }, 8, ["visible"])]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "myform-item"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      class: "myform-item-lable",
      span: 6
    }, {
      default: _withCtx(() => [_hoisted_5]),
      _: 1
    }), _createVNode(_component_el_col, {
      class: "myform-item-value",
      span: 18
    }, {
      default: _withCtx(() => [_createVNode(_component_el_popover, {
        visible: $data.err.pwd.visible,
        placement: "right"
      }, {
        reference: _withCtx(() => [_createVNode(_component_el_input, {
          style: {
            "width": "140px"
          },
          modelValue: $data.pwd,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.pwd = $event),
          modelModifiers: {
            trim: true
          },
          size: "small",
          placeholder: "请输入登录密码",
          clearable: "",
          "show-password": "",
          type: "password",
          onFocus: _cache[6] || (_cache[6] = $event => $data.err.pwd.visible = false)
        }, null, 8, ["modelValue"])]),
        default: _withCtx(() => [_createElementVNode("span", null, [_createVNode(_component_el_icon, {
          color: "red",
          size: "20px"
        }, {
          default: _withCtx(() => [_createVNode(_component_warning_filled)]),
          _: 1
        }), _createElementVNode("span", null, _toDisplayString($data.err.pwd.content), 1)])]),
        _: 1
      }, 8, ["visible"]), _hoisted_6]),
      _: 1
    })]),
    _: 1
  }), $data.add_user_data.group_id == 2 ? (_openBlock(), _createBlock(_component_el_row, {
    key: 0,
    class: "myform-item"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      class: "myform-item-lable",
      span: 6
    }, {
      default: _withCtx(() => [_hoisted_7]),
      _: 1
    }), _createVNode(_component_el_col, {
      class: "myform-item-value",
      span: 18
    }, {
      default: _withCtx(() => [_createVNode(_component_el_select, {
        style: {
          "width": "140px"
        },
        modelValue: $data.copy_user_id,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.copy_user_id = $event),
        placeholder: "请选择",
        size: "small"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.add_user_data.copy_list, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.id,
            label: item.username,
            value: item.id
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    })]),
    _: 1
  })) : _createCommentVNode("", true), $data.add_oc_url == 1 && $data.add_user_data.group_id < 4 ? (_openBlock(), _createBlock(_component_el_row, {
    key: 1,
    class: "myform-item"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      class: "myform-item-lable",
      span: 6
    }, {
      default: _withCtx(() => [_hoisted_8]),
      _: 1
    }), _createVNode(_component_el_col, {
      class: "myform-item-value",
      span: 18
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        style: {
          "width": "140px"
        },
        size: "small",
        modelValue: $data.note,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.note = $event),
        placeholder: "请输入公司名称"
      }, null, 8, ["modelValue"])]),
      _: 1
    })]),
    _: 1
  })) : _createCommentVNode("", true), $data.add_user_data.group_id == 2 ? (_openBlock(), _createBlock(_component_el_row, {
    key: 2,
    class: "myform-item"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      class: "myform-item-lable",
      span: 6
    }, {
      default: _withCtx(() => [_hoisted_9]),
      _: 1
    }), _createVNode(_component_el_col, {
      class: "myform-item-value",
      span: 18
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio_group, {
        modelValue: $data.bill_reset,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $data.bill_reset = $event)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio, {
          label: "1"
        }, {
          default: _withCtx(() => [_hoisted_10]),
          _: 1
        }), _createVNode(_component_el_radio, {
          label: "0"
        }, {
          default: _withCtx(() => [_hoisted_11]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    })]),
    _: 1
  })) : _createCommentVNode("", true), $data.add_user_data.group_id > 2 ? (_openBlock(), _createBlock(_component_el_row, {
    key: 3,
    class: "myform-item"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      class: "myform-item-lable",
      span: 6
    }, {
      default: _withCtx(() => [_hoisted_12]),
      _: 1
    }), _createVNode(_component_el_col, {
      class: "myform-item-value",
      span: 18
    }, {
      default: _withCtx(() => [$data.add_user_data.group_id == 3 ? (_openBlock(), _createBlock(_component_el_radio_group, {
        key: 0,
        modelValue: $data.bill_reset,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $data.bill_reset = $event)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio, {
          label: "0"
        }, {
          default: _withCtx(() => [_hoisted_13]),
          _: 1
        }), _createVNode(_component_el_radio, {
          label: "1"
        }, {
          default: _withCtx(() => [_hoisted_14]),
          _: 1
        }), _createVNode(_component_el_radio, {
          label: "2"
        }, {
          default: _withCtx(() => [_hoisted_15]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])) : _createCommentVNode("", true), $data.add_user_data.group_id > 3 ? (_openBlock(), _createBlock(_component_el_radio_group, {
        key: 1,
        modelValue: $data.bill_reset,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => $data.bill_reset = $event)
      }, {
        default: _withCtx(() => [$data.add_user_data.bill_reset == '1' || $data.add_user_data.bill_reset == '0' ? (_openBlock(), _createBlock(_component_el_radio, {
          key: 0,
          label: "0"
        }, {
          default: _withCtx(() => [_hoisted_16]),
          _: 1
        })) : _createCommentVNode("", true), $data.add_user_data.bill_reset == '1' || $data.add_user_data.bill_reset == '2' ? (_openBlock(), _createBlock(_component_el_radio, {
          key: 1,
          label: "2"
        }, {
          default: _withCtx(() => [_hoisted_17]),
          _: 1
        })) : _createCommentVNode("", true), $data.add_user_data.bill_reset == '1' ? (_openBlock(), _createBlock(_component_el_radio, {
          key: 2,
          label: "1"
        }, {
          default: _withCtx(() => [_hoisted_18]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue"])) : _createCommentVNode("", true)]),
      _: 1
    })]),
    _: 1
  })) : _createCommentVNode("", true), ($data.add_user_data.group_id == 2 || $data.add_user_data.group_id == 3 || $data.add_user_data.group_id == 4) && $data.add_user_data.trader_status == 1 ? (_openBlock(), _createBlock(_component_el_row, {
    key: 4,
    class: "myform-item"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      class: "myform-item-lable",
      span: 6
    }, {
      default: _withCtx(() => [_hoisted_19]),
      _: 1
    }), _createVNode(_component_el_col, {
      class: "myform-item-value",
      span: 18
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio_group, {
        modelValue: $data.trader_status,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => $data.trader_status = $event)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio, {
          label: "1"
        }, {
          default: _withCtx(() => [_hoisted_20]),
          _: 1
        }), _createVNode(_component_el_radio, {
          label: "0"
        }, {
          default: _withCtx(() => [_hoisted_21]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    })]),
    _: 1
  })) : _createCommentVNode("", true), $data.add_user_data.trader_diff_user == 1 ? (_openBlock(), _createBlock(_component_el_row, {
    key: 5,
    class: "myform-item"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      class: "myform-item-lable",
      span: 6
    }, {
      default: _withCtx(() => [_hoisted_22]),
      _: 1
    }), _createVNode(_component_el_col, {
      class: "myform-item-value",
      span: 18
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio_group, {
        modelValue: $data.trader_diff.status,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => $data.trader_diff.status = $event)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio, {
          label: "1"
        }, {
          default: _withCtx(() => [_hoisted_23]),
          _: 1
        }), _createVNode(_component_el_radio, {
          label: "0"
        }, {
          default: _withCtx(() => [_hoisted_24]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]), $data.trader_diff.status === '1' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createVNode(_component_el_input, {
        style: {
          "width": "60px",
          "margin-left": "6px"
        },
        size: "small",
        modelValue: $data.trader_diff.diff[0],
        "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => $data.trader_diff.diff[0] = $event)
      }, null, 8, ["modelValue"]), _hoisted_25, _createVNode(_component_el_input, {
        style: {
          "width": "60px"
        },
        size: "small",
        modelValue: $data.trader_diff.diff[1],
        "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => $data.trader_diff.diff[1] = $event)
      }, null, 8, ["modelValue"]), _createTextVNode("   最高赚取" + _toDisplayString($data.trader_diff.diff[1]) + "赔率差 ", 1)], 64)) : _createCommentVNode("", true)]),
      _: 1
    })]),
    _: 1
  })) : _createCommentVNode("", true), _withDirectives(_createVNode(_component_el_row, {
    class: "myform-item"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      class: "myform-item-lable",
      span: 6
    }, {
      default: _withCtx(() => [_hoisted_26]),
      _: 1
    }), _createVNode(_component_el_col, {
      class: "myform-item-value",
      span: 18
    }, {
      default: _withCtx(() => [_createVNode(_component_el_checkbox_group, {
        modelValue: $data.user_play_status_list,
        "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => $data.user_play_status_list = $event),
        onChange: $options.change_user_play_status_list
      }, {
        default: _withCtx(() => [$data.add_user_data.status_kuaicai == 1 ? (_openBlock(), _createBlock(_component_el_checkbox, {
          key: 0,
          label: "1"
        }, {
          default: _withCtx(() => [_hoisted_27]),
          _: 1
        })) : _createCommentVNode("", true), $data.add_user_data.status_liuhe == 1 ? (_openBlock(), _createBlock(_component_el_checkbox, {
          key: 1,
          label: "2"
        }, {
          default: _withCtx(() => [_hoisted_28]),
          _: 1
        })) : _createCommentVNode("", true), $data.add_user_data.status_aomen == 1 ? (_openBlock(), _createBlock(_component_el_checkbox, {
          key: 2,
          label: "3"
        }, {
          default: _withCtx(() => [_hoisted_29]),
          _: 1
        })) : _createCommentVNode("", true), $data.add_user_data.status_xinaomen == 1 ? (_openBlock(), _createBlock(_component_el_checkbox, {
          key: 3,
          label: "4"
        }, {
          default: _withCtx(() => [_hoisted_30]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue", "onChange"])]),
      _: 1
    })]),
    _: 1
  }, 512), [[_vShow, $data.add_user_data.group_id > 2]]), $data.user_play_status_list.includes('1') ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 6
  }, [_createVNode(_component_el_row, {
    class: "myform-item"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      class: "myform-item-lable",
      span: 6
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString($props.addinfo.sup_group_name) + "保留占成(快彩)", 1)]),
      _: 1
    }), _createVNode(_component_el_col, {
      class: "myform-item-value",
      span: 18
    }, {
      default: _withCtx(() => [_createVNode(_component_el_popover, {
        visible: $data.err.kuaicai_sup_occupy_lock.visible,
        placement: "right"
      }, {
        reference: _withCtx(() => [_createVNode(_component_el_input, {
          style: {
            "width": "140px"
          },
          modelValue: $data.kuaicai_sup_occupy_lock,
          "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => $data.kuaicai_sup_occupy_lock = $event),
          modelModifiers: {
            trim: true
          },
          size: "small",
          min: "0",
          onFocus: _cache[18] || (_cache[18] = $event => $data.err.kuaicai_sup_occupy_lock.visible = false)
        }, null, 8, ["modelValue"])]),
        default: _withCtx(() => [_createElementVNode("span", null, [_createVNode(_component_el_icon, {
          color: "red",
          size: "20px"
        }, {
          default: _withCtx(() => [_createVNode(_component_warning_filled)]),
          _: 1
        }), _createElementVNode("span", null, _toDisplayString($data.err.kuaicai_sup_occupy_lock.content), 1)])]),
        _: 1
      }, 8, ["visible"]), _createTextVNode(" 最高可设占成：" + _toDisplayString($data.add_user_data.kuaicai_max_sup_lock) + "% ", 1)]),
      _: 1
    })]),
    _: 1
  }), this.add_user_data.kuaicai_max_sup_lock * 1 > 0 ? (_openBlock(), _createBlock(_component_el_row, {
    key: 0,
    class: "myform-item"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      class: "myform-item-lable",
      span: 6
    }, {
      default: _withCtx(() => [_hoisted_31]),
      _: 1
    }), _createVNode(_component_el_col, {
      class: "myform-item-value",
      span: 18
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio_group, {
        modelValue: $data.kuaicai_allowmaxrate_kc,
        "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => $data.kuaicai_allowmaxrate_kc = $event),
        onChange: $options.change_rzxz_kc
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio, {
          label: "0"
        }, {
          default: _withCtx(() => [_hoisted_32]),
          _: 1
        }), _createVNode(_component_el_radio, {
          label: "1"
        }, {
          default: _withCtx(() => [_hoisted_33]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue", "onChange"]), $data.kuaicai_allowmaxrate_kc == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_34, [_createVNode(_component_el_popover, {
        visible: $data.err.kuaicai_lowmaxrate_kc.visible,
        placement: "right"
      }, {
        reference: _withCtx(() => [_createVNode(_component_el_input, {
          style: {
            "width": "100px"
          },
          min: "0",
          modelValue: $data.kuaicai_lowmaxrate_kc,
          "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => $data.kuaicai_lowmaxrate_kc = $event),
          modelModifiers: {
            trim: true
          },
          size: "small",
          placeholder: "留空默认为0",
          onFocus: _cache[21] || (_cache[21] = $event => $data.err.kuaicai_lowmaxrate_kc.visible = false)
        }, null, 8, ["modelValue"])]),
        default: _withCtx(() => [_createElementVNode("span", null, [_createVNode(_component_el_icon, {
          color: "red",
          size: "20px"
        }, {
          default: _withCtx(() => [_createVNode(_component_warning_filled)]),
          _: 1
        }), _createElementVNode("span", null, _toDisplayString($data.err.kuaicai_lowmaxrate_kc.content), 1)])]),
        _: 1
      }, 8, ["visible"]), $data.add_user_data.group_id > 1 ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createTextVNode("最高" + _toDisplayString($data.add_user_data.kuaicai_max_sup_lock * 1 - $data.kuaicai_sup_occupy_lock * 1) + " %", 1)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createTextVNode("最高" + _toDisplayString($data.add_user_data.kuaicai_max_sup_lock * 1) + " %", 1)], 64))])) : _createCommentVNode("", true)]),
      _: 1
    })]),
    _: 1
  })) : _createCommentVNode("", true), $data.add_user_data.group_id == 2 || $data.add_user_data.group_id == 3 || $data.add_user_data.group_id == 4 ? (_openBlock(), _createBlock(_component_el_row, {
    key: 1,
    class: "myform-item"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      class: "myform-item-lable",
      span: 6
    }, {
      default: _withCtx(() => [_hoisted_35]),
      _: 1
    }), _createVNode(_component_el_col, {
      class: "myform-item-value",
      span: 18
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio_group, {
        modelValue: $data.kuaicai_remainder,
        "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => $data.kuaicai_remainder = $event)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio, {
          label: "0"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString($props.addinfo.sup_group_name), 1)]),
          _: 1
        }), _createVNode(_component_el_radio, {
          label: "1"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString($props.addinfo.sub_group_name), 1)]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    })]),
    _: 1
  })) : _createCommentVNode("", true), _createVNode(_component_el_row, {
    class: "myform-item"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      class: "myform-item-lable",
      span: 6
    }, {
      default: _withCtx(() => [_hoisted_36]),
      _: 1
    }), _createVNode(_component_el_col, {
      class: "myform-item-value",
      span: 18
    }, {
      default: _withCtx(() => [_createVNode(_component_el_checkbox_group, {
        modelValue: $data.kuaicai_level_id,
        "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => $data.kuaicai_level_id = $event),
        size: "small",
        onChange: $options.change_kuaicai_pk
      }, {
        default: _withCtx(() => [this.add_user_data.kuaicai_level_id.includes('0') ? (_openBlock(), _createBlock(_component_el_checkbox, {
          key: 0,
          label: "0"
        }, {
          default: _withCtx(() => [_hoisted_37]),
          _: 1
        })) : _createCommentVNode("", true), this.add_user_data.kuaicai_level_id.includes('0') || this.add_user_data.kuaicai_level_id.includes('1') ? (_openBlock(), _createBlock(_component_el_checkbox, {
          key: 1,
          label: "1"
        }, {
          default: _withCtx(() => [_hoisted_38]),
          _: 1
        })) : _createCommentVNode("", true), this.add_user_data.kuaicai_level_id.includes('0') || this.add_user_data.kuaicai_level_id.includes('2') ? (_openBlock(), _createBlock(_component_el_checkbox, {
          key: 2,
          label: "2"
        }, {
          default: _withCtx(() => [_hoisted_39]),
          _: 1
        })) : _createCommentVNode("", true), this.add_user_data.kuaicai_level_id.includes('0') || this.add_user_data.kuaicai_level_id.includes('3') ? (_openBlock(), _createBlock(_component_el_checkbox, {
          key: 3,
          label: "3"
        }, {
          default: _withCtx(() => [_hoisted_40]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue", "onChange"])]),
      _: 1
    })]),
    _: 1
  })], 64)) : _createCommentVNode("", true), $data.user_play_status_list.includes('2') || $data.user_play_status_list.includes('3') || $data.user_play_status_list.includes('4') ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 7
  }, [_createVNode(_component_el_row, {
    class: "myform-item"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      class: "myform-item-lable",
      span: 6
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString($props.addinfo.sup_group_name) + "保留占成(六合)", 1)]),
      _: 1
    }), _createVNode(_component_el_col, {
      class: "myform-item-value",
      span: 18
    }, {
      default: _withCtx(() => [_createVNode(_component_el_popover, {
        visible: $data.err.sup_occupy_lock.visible,
        placement: "right"
      }, {
        reference: _withCtx(() => [_createVNode(_component_el_input, {
          style: {
            "width": "140px"
          },
          modelValue: $data.sup_occupy_lock,
          "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => $data.sup_occupy_lock = $event),
          modelModifiers: {
            trim: true
          },
          size: "small",
          min: "0",
          onFocus: _cache[25] || (_cache[25] = $event => $data.err.sup_occupy_lock.visible = false)
        }, null, 8, ["modelValue"])]),
        default: _withCtx(() => [_createElementVNode("span", null, [_createVNode(_component_el_icon, {
          color: "red",
          size: "20px"
        }, {
          default: _withCtx(() => [_createVNode(_component_warning_filled)]),
          _: 1
        }), _createElementVNode("span", null, _toDisplayString($data.err.sup_occupy_lock.content), 1)])]),
        _: 1
      }, 8, ["visible"]), _createTextVNode(" 最高可设占成：" + _toDisplayString($data.add_user_data.max_sup_lock) + "% ", 1)]),
      _: 1
    })]),
    _: 1
  }), $data.add_user_data.max_sup_lock * 1 > 0 ? (_openBlock(), _createBlock(_component_el_row, {
    key: 0,
    class: "myform-item"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      class: "myform-item-lable",
      span: 6
    }, {
      default: _withCtx(() => [_hoisted_41]),
      _: 1
    }), _createVNode(_component_el_col, {
      class: "myform-item-value",
      span: 18
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio_group, {
        modelValue: $data.allowmaxrate_kc,
        "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => $data.allowmaxrate_kc = $event),
        onChange: $options.change_rzxz_lhc
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio, {
          label: "0"
        }, {
          default: _withCtx(() => [_hoisted_42]),
          _: 1
        }), _createVNode(_component_el_radio, {
          label: "1"
        }, {
          default: _withCtx(() => [_hoisted_43]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue", "onChange"]), $data.allowmaxrate_kc == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_44, [_createVNode(_component_el_popover, {
        visible: $data.err.lowmaxrate_kc.visible,
        placement: "right"
      }, {
        reference: _withCtx(() => [_createVNode(_component_el_input, {
          style: {
            "width": "100px"
          },
          modelValue: $data.lowmaxrate_kc,
          "onUpdate:modelValue": _cache[27] || (_cache[27] = $event => $data.lowmaxrate_kc = $event),
          modelModifiers: {
            trim: true
          },
          size: "small",
          min: "0",
          placeholder: "留空默认为0",
          onFocus: _cache[28] || (_cache[28] = $event => $data.err.lowmaxrate_kc.visible = false)
        }, null, 8, ["modelValue"])]),
        default: _withCtx(() => [_createElementVNode("span", null, [_createVNode(_component_el_icon, {
          color: "red",
          size: "20px"
        }, {
          default: _withCtx(() => [_createVNode(_component_warning_filled)]),
          _: 1
        }), _createElementVNode("span", null, _toDisplayString($data.err.lowmaxrate_kc.content), 1)])]),
        _: 1
      }, 8, ["visible"]), $data.add_user_data.group_id > 1 ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createTextVNode("最高" + _toDisplayString($data.add_user_data.max_sup_lock * 1 - $data.sup_occupy_lock * 1) + " %", 1)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createTextVNode("最高" + _toDisplayString($data.add_user_data.max_sup_lock * 1) + " %", 1)], 64))])) : _createCommentVNode("", true)]),
      _: 1
    })]),
    _: 1
  })) : _createCommentVNode("", true), $data.add_user_data.group_id == 2 || $data.add_user_data.group_id == 3 || $data.add_user_data.group_id == 4 ? (_openBlock(), _createBlock(_component_el_row, {
    key: 1,
    class: "myform-item"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      class: "myform-item-lable",
      span: 6
    }, {
      default: _withCtx(() => [_hoisted_45]),
      _: 1
    }), _createVNode(_component_el_col, {
      class: "myform-item-value",
      span: 18
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio_group, {
        modelValue: $data.remainder,
        "onUpdate:modelValue": _cache[29] || (_cache[29] = $event => $data.remainder = $event)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio, {
          label: "0"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString($props.addinfo.sup_group_name), 1)]),
          _: 1
        }), _createVNode(_component_el_radio, {
          label: "1"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString($props.addinfo.sub_group_name), 1)]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    })]),
    _: 1
  })) : _createCommentVNode("", true), _createVNode(_component_el_row, {
    class: "myform-item"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      class: "myform-item-lable",
      span: 6
    }, {
      default: _withCtx(() => [_hoisted_46]),
      _: 1
    }), _createVNode(_component_el_col, {
      class: "myform-item-value",
      span: 18
    }, {
      default: _withCtx(() => [_createVNode(_component_el_checkbox_group, {
        modelValue: $data.level_id,
        "onUpdate:modelValue": _cache[30] || (_cache[30] = $event => $data.level_id = $event),
        size: "small",
        onChange: $options.change_pk
      }, {
        default: _withCtx(() => [$data.add_user_data.level_id.includes('0') ? (_openBlock(), _createBlock(_component_el_checkbox, {
          key: 0,
          label: "0"
        }, {
          default: _withCtx(() => [_hoisted_47]),
          _: 1
        })) : _createCommentVNode("", true), $data.add_user_data.level_id.includes('0') || $data.add_user_data.level_id.includes('1') ? (_openBlock(), _createBlock(_component_el_checkbox, {
          key: 1,
          label: "1"
        }, {
          default: _withCtx(() => [_hoisted_48]),
          _: 1
        })) : _createCommentVNode("", true), $data.add_user_data.level_id.includes('0') || $data.add_user_data.level_id.includes('2') ? (_openBlock(), _createBlock(_component_el_checkbox, {
          key: 2,
          label: "2"
        }, {
          default: _withCtx(() => [_hoisted_49]),
          _: 1
        })) : _createCommentVNode("", true), $data.add_user_data.level_id.includes('0') || $data.add_user_data.level_id.includes('3') ? (_openBlock(), _createBlock(_component_el_checkbox, {
          key: 3,
          label: "3"
        }, {
          default: _withCtx(() => [_hoisted_50]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue", "onChange"])]),
      _: 1
    })]),
    _: 1
  })], 64)) : _createCommentVNode("", true), _createVNode(_component_el_row, {
    class: "myform-item"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      class: "myform-item-lable",
      span: 6
    }, {
      default: _withCtx(() => [_hoisted_51]),
      _: 1
    }), _createVNode(_component_el_col, {
      class: "myform-item-value",
      span: 18
    }, {
      default: _withCtx(() => [_createVNode(_component_el_select, {
        modelValue: $data.kuaicai_auto_draw_back.value,
        "onUpdate:modelValue": _cache[31] || (_cache[31] = $event => $data.kuaicai_auto_draw_back.value = $event),
        placeholder: "自定义",
        size: "small",
        onChange: _cache[32] || (_cache[32] = $event => $options.draw_back_change('', $event))
      }, {
        default: _withCtx(() => [_createVNode(_component_el_option, {
          label: "水全退到底",
          value: "0"
        }), _createVNode(_component_el_option, {
          label: "赚取 0.1 退水",
          value: "0.1"
        }), _createVNode(_component_el_option, {
          label: "赚取 0.2 退水",
          value: "0.2"
        }), _createVNode(_component_el_option, {
          label: "赚取 0.3 退水",
          value: "0.3"
        }), _createVNode(_component_el_option, {
          label: "赚取 0.4 退水",
          value: "0.4"
        }), _createVNode(_component_el_option, {
          label: "赚取所有退水",
          value: "all"
        }), _createVNode(_component_el_option, {
          label: "自定义",
          value: "auto"
        })]),
        _: 1
      }, 8, ["modelValue"]), $data.kuaicai_auto_draw_back.show ? (_openBlock(), _createElementBlock("span", _hoisted_52, [_hoisted_53, _createVNode(_component_el_input, {
        name: "auto_draw_back",
        modelValue: $data.kuaicai_auto_draw_back.value,
        "onUpdate:modelValue": _cache[33] || (_cache[33] = $event => $data.kuaicai_auto_draw_back.value = $event),
        size: "small",
        style: {
          "width": "140px"
        }
      }, null, 8, ["modelValue"])])) : _createCommentVNode("", true)]),
      _: 1
    })]),
    _: 1
  }), $data.add_user_data.group_id > 1 && $data.add_user_data.autolet_status == 1 ? (_openBlock(), _createBlock(_component_el_row, {
    key: 8,
    class: "myform-item"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      class: "myform-item-lable",
      span: 6
    }, {
      default: _withCtx(() => [_hoisted_54]),
      _: 1
    }), _createVNode(_component_el_col, {
      class: "myform-item-value",
      span: 18
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio_group, {
        modelValue: $data.is_manlet,
        "onUpdate:modelValue": _cache[34] || (_cache[34] = $event => $data.is_manlet = $event)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio, {
          label: "1"
        }, {
          default: _withCtx(() => [_hoisted_55]),
          _: 1
        }), _createVNode(_component_el_radio, {
          label: "0"
        }, {
          default: _withCtx(() => [_hoisted_56]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    })]),
    _: 1
  })) : _createCommentVNode("", true), _createVNode(_component_el_row, {
    class: "myform-item"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      class: "myform-item-lable",
      span: 6
    }, {
      default: _withCtx(() => [_hoisted_57]),
      _: 1
    }), _createVNode(_component_el_col, {
      class: "myform-item-value",
      span: 18
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio_group, {
        modelValue: $data.status,
        "onUpdate:modelValue": _cache[35] || (_cache[35] = $event => $data.status = $event)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio, {
          label: "1"
        }, {
          default: _withCtx(() => [_hoisted_58]),
          _: 1
        }), _createVNode(_component_el_radio, {
          label: "0"
        }, {
          default: _withCtx(() => [_hoisted_59]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    })]),
    _: 1
  }), $data.user_play_status_list.includes('1') ? (_openBlock(), _createBlock(_component_el_row, {
    key: 9,
    class: "myform-item"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      class: "myform-item-lable",
      span: 6
    }, {
      default: _withCtx(() => [_hoisted_60]),
      _: 1
    }), _createVNode(_component_el_col, {
      class: "myform-item-value",
      span: 18
    }, {
      default: _withCtx(() => [_createVNode(_component_el_popover, {
        visible: $data.err.kuaicai_userCredit_kc.visible,
        placement: "top"
      }, {
        reference: _withCtx(() => [_createVNode(_component_el_input, {
          style: {
            "width": "140px"
          },
          modelValue: $data.kuaicai_userCredit_kc,
          "onUpdate:modelValue": _cache[36] || (_cache[36] = $event => $data.kuaicai_userCredit_kc = $event),
          modelModifiers: {
            trim: true
          },
          size: "small",
          clearable: "",
          onFocus: _cache[37] || (_cache[37] = $event => $data.err.kuaicai_userCredit_kc.visible = false),
          min: "0",
          max: $data.add_user_data.kuaicai_balance * 1
        }, null, 8, ["modelValue", "max"])]),
        default: _withCtx(() => [_createElementVNode("span", null, [_createVNode(_component_el_icon, {
          color: "red",
          size: "20px"
        }, {
          default: _withCtx(() => [_createVNode(_component_warning_filled)]),
          _: 1
        }), _createElementVNode("span", null, _toDisplayString($data.err.kuaicai_userCredit_kc.content), 1)])]),
        _: 1
      }, 8, ["visible"]), _createElementVNode("span", null, "  上级余额：" + _toDisplayString($data.add_user_data.kuaicai_balance), 1)]),
      _: 1
    })]),
    _: 1
  })) : _createCommentVNode("", true), $data.user_play_status_list.includes('2') || $data.user_play_status_list.includes('3') || $data.user_play_status_list.includes('4') ? (_openBlock(), _createBlock(_component_el_row, {
    key: 10,
    class: "myform-item"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      class: "myform-item-lable",
      span: 6
    }, {
      default: _withCtx(() => [_hoisted_61]),
      _: 1
    }), _createVNode(_component_el_col, {
      class: "myform-item-value",
      span: 18
    }, {
      default: _withCtx(() => [_createVNode(_component_el_popover, {
        visible: $data.err.userCredit_kc.visible,
        placement: "top"
      }, {
        reference: _withCtx(() => [_createVNode(_component_el_input, {
          style: {
            "width": "140px"
          },
          modelValue: $data.userCredit_kc,
          "onUpdate:modelValue": _cache[38] || (_cache[38] = $event => $data.userCredit_kc = $event),
          modelModifiers: {
            trim: true
          },
          size: "small",
          clearable: "",
          onFocus: _cache[39] || (_cache[39] = $event => $data.err.userCredit_kc.visible = false),
          min: "0",
          max: $data.add_user_data.balance * 1
        }, null, 8, ["modelValue", "max"])]),
        default: _withCtx(() => [_createElementVNode("span", null, [_createVNode(_component_el_icon, {
          color: "red",
          size: "20px"
        }, {
          default: _withCtx(() => [_createVNode(_component_warning_filled)]),
          _: 1
        }), _createElementVNode("span", null, _toDisplayString($data.err.userCredit_kc.content), 1)])]),
        _: 1
      }, 8, ["visible"]), _createElementVNode("span", null, "  上级余额：" + _toDisplayString($data.add_user_data.balance), 1)]),
      _: 1
    })]),
    _: 1
  })) : _createCommentVNode("", true)]), _createVNode(_component_el_button, {
    style: {
      "margin-top": "10px"
    },
    size: "small",
    type: "primary",
    onClick: $options.post_change
  }, {
    default: _withCtx(() => [_hoisted_62]),
    _: 1
  }, 8, ["onClick"])]);
}